import * as types from '../ActionTypes/MetaActionTypes';

const initialState = {
    token: '',
    password: '',
};

export function MetaReducer(state = initialState, { type, payload, meta, ...action }) {
    switch (type) {
        case types.SET_REFRESH_HASH: {
            return {
                token: payload,
            };
        }

        case types.CLEAR_HASH: {
            return {
                ...state,
                token: '',
            };
        }

        case types.SET_PASSWORD_REQUEST: {
            return {
                ...state,
                password: payload,
            };
        }

        case types.SET_PASSWORD_SUCCESS: {
            return initialState;
        }

        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Store/Reducers/MetaReducer.js